export enum FlexBoxAlignItems {
  Start = 'Start',
  Center = 'Center',
  End = 'End',
  Baseline = 'Baseline',
  Stretch = 'Stretch'
}
